import { useEffect, useMemo, useState } from "react";

const frames = [
  { lines: ["MADONNA"], mode: "regular", theme: "mono", duration: 340 },
  { lines: ["MADONNA"], mode: "oversized", theme: "mono", duration: 320 },
  { lines: ["LONDON"], mode: "regular", theme: "red", duration: 340 },
  { lines: ["LONDON"], mode: "oversized", theme: "pink", duration: 320 },
  { lines: ["C’MON"], mode: "call", theme: "mono", duration: 360 },
  { lines: ["C’MON", "MEET ME ON", "THE DANCEFLOOR"], mode: "final", theme: "red", duration: 900 },
] as const;

interface Props {
  onComplete: () => void;
}

export function KineticIntro({ onComplete }: Props) {
  const forcedFrame = useMemo(() => {
    const value = new URLSearchParams(window.location.search).get("introFrame");
    if (value === null) return null;
    const parsed = Number.parseInt(value, 10);
    return Number.isInteger(parsed) && parsed >= 0 && parsed < frames.length ? parsed : null;
  }, []);
  const reducedMotion = useMemo(
    () => window.matchMedia("(prefers-reduced-motion: reduce)").matches,
    [],
  );
  const [frame, setFrame] = useState(forcedFrame ?? (reducedMotion ? frames.length - 1 : 0));
  const current = frames[frame];

  useEffect(() => {
    const timeout = window.setTimeout(() => {
      if (forcedFrame !== null) return;
      if (reducedMotion || frame === frames.length - 1) {
        onComplete();
        return;
      }
      setFrame((value) => value + 1);
    }, reducedMotion ? 800 : current.duration);

    return () => window.clearTimeout(timeout);
  }, [current.duration, forcedFrame, frame, onComplete, reducedMotion]);

  return (
    <section
      className={`kinetic-intro kinetic-intro--${current.mode} kinetic-intro--theme-${current.theme}`}
      aria-label="Madonna. London. C’mon meet me on the dancefloor."
      data-frame={frame}
    >
      <p className="kinetic-intro__word" key={frame} aria-hidden="true">
        {current.lines.map((line) => <span key={line}>{line}</span>)}
      </p>
    </section>
  );
}
